import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useCallback } from 'react';

import { useSendUserEngagementIncrement } from 'hooks/useSendUserEngagementIncrement';
import { UserEngagementScoreIncrement_Source } from 'protos/webview/channel/native_messages';

import type { useClaimReferralReward_referralReward } from './__generated__/useClaimReferralReward.graphql';
import { useCoreClaimReferralReward } from './useCoreClaimReferralReward';

export const useClaimReferralReward = () => {
  const { sendUserEngagementIncrement } = useSendUserEngagementIncrement();

  const claimCore = useCoreClaimReferralReward();

  return useCallback(
    (referralReward_: useClaimReferralReward_referralReward) => {
      const referralReward = referralReward_;
      claimCore(referralReward.id);
      sendUserEngagementIncrement(
        70,
        UserEngagementScoreIncrement_Source.CLAIM_REFERRABLE_REWARD
      );
    },
    [claimCore, sendUserEngagementIncrement]
  );
};

useClaimReferralReward.fragments = {
  referralReward: gql`
    fragment useClaimReferralReward_referralReward on ReferralReward {
      id
      conversionCredit {
        id
      }
      card: anyCard {
        slug
        sport
      }
    }
  ` as TypedDocumentNode<useClaimReferralReward_referralReward>,
};
